import { SupplierService } from "./supplier.service";
import { Injectable } from "@angular/core";
import { MerchantService } from "./merchant.service";
import { PosService } from "./pos.service";
import { TransactionService } from "./transaction.service";
import { NotifMessageService } from "./notifmessage.service";
import { UserService } from "./user.service";
import { UserPager } from "../models/pagers/user-pager";
import { EventService } from "./event.service";
import { ErrorService } from "./error.service";
import { Subscription } from "rxjs";
import { FuellingproviderService } from "./fuellingprovider.service";
import { PaymentTransactionsService } from "./payment-transactions.service";
import { AcceptanceAccountsService } from "./acceptanceAccounts.service";

@Injectable({ providedIn: 'root' })
export class PaginationService {

  constructor(
    private supplierService: SupplierService,
    private merchantService: MerchantService,
    private notifService: NotifMessageService,
    private posService: PosService,
    private transactionService: TransactionService,
    private paymentTransactionService: PaymentTransactionsService,
    private userService: UserService,
    private eventService: EventService,
    private errorService: ErrorService,
    private fuellingProviderService: FuellingproviderService,
    private acceptanceAccountService: AcceptanceAccountsService
  ) { }

  pageSizeItems: number[] = [20, 50, 100];

  pageChange(type, criteria, pager, isDeletedIncluded:boolean=false) {
    pager["page"] = pager["page"] - 1;

    switch (type) {
      case "supplier":
        let subSupplier: Subscription = this.supplierService.findByCriteria(criteria, pager,true).subscribe(suppliers => {  if (suppliers.empty) {
            this.notifService.notifyInfo('EMPTY_RESULT');
          }
          this.supplierService.emitSupplierPager(suppliers);
          subSupplier.unsubscribe();
        });
        break;
      case "merchant":
        let subMerchant: Subscription = this.merchantService.findByCriteria(criteria, pager, true).subscribe(merchants => {  if (merchants.empty) {
          this.notifService.notifyInfo('EMPTY_RESULT');
          }
          this.merchantService.emitMerchantPager(merchants);
          subMerchant.unsubscribe();
        });
        break;
      case "pos":
        let subPoS: Subscription = this.posService.findByCriteria(criteria, pager, isDeletedIncluded).subscribe(pos => {
          if (pos.empty === undefined || pos.empty) {
            this.notifService.notifyInfo('EMPTY_RESULT');
          }
          this.posService.emitPosPager(pos);
          subPoS.unsubscribe();
        });
        break;
      case "event":
        let subEvent: Subscription = this.eventService.findByCriteria(criteria, pager).subscribe(events => {

          if (events.empty === undefined || events.empty) {
            this.notifService.notifyInfo('EMPTY_RESULT');
          } else if (criteria.from > criteria.to) {
            this.notifService.notifyErrorWithoutDetail('ERROR_DATE');
          }
          this.eventService.emitEventPager(events);
          subEvent.unsubscribe();
        });
        break;
      case "error":
        let subError: Subscription = this.errorService.findByCriteria(criteria, pager).subscribe(errors => {
          if (errors.empty === undefined || errors.empty) {
            this.notifService.notifyInfo('EMPTY_RESULT');
          } else if (criteria.from > criteria.to) {
            this.notifService.notifyErrorWithoutDetail('ERROR_DATE');
          }
          this.errorService.emitErrorPager(errors);
          subError.unsubscribe();
        });
        break;
      case "transaction":
        this.transactionService.findByCriteria(criteria, pager).subscribe(transactions => {
          if (transactions.empty === undefined || transactions.empty) {
            this.notifService.notifyInfo('EMPTY_RESULT');
          }
          this.transactionService.emitTransactionPager(transactions);
        });
        break;

      case "paymentTransaction":
        this.paymentTransactionService.findByCriteria(criteria, pager).subscribe(paymentTransactions => {
          if (paymentTransactions.empty === undefined || paymentTransactions.empty) {
            this.notifService.notifyInfo('EMPTY_RESULT');
          }
          this.paymentTransactionService.emitTransactionPager(paymentTransactions);
        });
        break;

      case "user":
        let userPager: UserPager;
        userPager = {
          first: pager["page"] * pager["max"],
          max: pager["max"],
          sortBy: pager["sortBy"],
          order: pager["order"],
        }
        if (criteria["merchantId"]) {
          userPager["merchantId"] = criteria["merchantId"];
        }
        if (criteria["supplierId"]) {
          userPager["supplierId"] = criteria["supplierId"];
        }
        if (criteria["search"]) {
          userPager["search"] = criteria["search"];
        }
        if (criteria["roleName"]) {
          userPager["roleName"] = criteria["roleName"];
        }

        this.userService.getUsers(userPager).subscribe(users => {
          this.userService.emitUsers(users);
          if (users && users.length == 0) {
            this.notifService.notifyInfo('EMPTY_RESULT');
          }
        });
        break;
      case "fuellingprovider":
        let subFprovider: Subscription = this.fuellingProviderService.findByCriteria(criteria, pager, isDeletedIncluded).subscribe(fprovider => {
          if (fprovider.empty === undefined || fprovider.empty) {
            this.notifService.notifyInfo('EMPTY_RESULT');
          }
          this.fuellingProviderService.emitFuellingproviderPager(fprovider);
          subFprovider.unsubscribe();
        });
        break;
        case "acceptanceaccount":
        let subAccAccount: Subscription = this.acceptanceAccountService.findByCriteria(criteria, pager, isDeletedIncluded).subscribe(accac => {
          if (accac.empty) {
            this.notifService.notifyInfo('EMPTY_RESULT');
          }
          this.acceptanceAccountService.emitacceptanceaccountPager(accac);
          subAccAccount.unsubscribe();
        });
        break;

      default:
        break;
    }

  }
}
